'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getActiveElement = {};

exports.__exports = getActiveElement;
